import { FirebaseActions } from '@web_opxp/features';

export const medBannerClickedAction = () =>
  FirebaseActions.analyticsEvent({
    eventName: 'v_banner_clicked',
    parameters: [
      {
        key: 'Location',
        value: 'Onboarding',
      },
      {
        key: 'Campaign',
        value: 'Med',
      },
    ],
  });

export const medBannerClosedAction = () =>
  FirebaseActions.analyticsEvent({
    eventName: 'v_banner_closed',
    parameters: [
      {
        key: 'Location',
        value: 'Onboarding',
      },
      {
        key: 'Campaign',
        value: 'Med',
      },
    ],
  });
